<section
  class="cta-container rounded-3xl pt-32 pb-32 grid grid-cols-1 md:grid-cols-3 items-center"
  data-aos="fade-up"
>
  <!-- Man Avatar - Right -->
  <div class="h-full hidden md:flex justify-center items-end ltr:order-last">
    <img src="assets/images/recruiter-program/avatar-man.png" alt="" />
  </div>

  <!-- Content -->
  <div class="flex flex-col items-center">
    <h2
      class="text-[28px] md:text-[36px] lg:text-[40px] font-extrabold leading-tight text-white text-center"
    >
      {{ "recruiterProgram.cta.title" | translate }}
    </h2>
    <p class="text-base text-white/80 leading-[1.75] text-center mt-3">
      {{ "recruiterProgram.cta.subtitle" | translate }}
    </p>
    <a
      [href]="getSignupUrl()"
      class="mt-8 text-white bg-[#1B54FF] rounded-full py-3.5 px-8 text-base font-medium hover:bg-[#1B54FF]/25 transition-colors"
    >
      {{ "recruiterProgram.cta.button" | translate }}
    </a>
  </div>

  <!-- Woman Avatar - Left -->
  <div class="h-full hidden md:flex justify-center items-start ltr:order-first">
    <img src="assets/images/recruiter-program/avatar-woman.png" alt="" />
  </div>
</section>
